import React, { useState, useEffect } from "react";
import { Box, Text, Layer, Button } from "grommet"; // Import Text for disclaimer
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { QuizFields } from "../../components/ManagerPortal/QuizFields";
import { QuizSummary } from "../../components/ManagerPortal/QuizSummary";
import { LinkPrevious } from "grommet-icons";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import API_URL from "../../config/config";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useQuizContext } from "../../contexts/QuizContext";
import { useSequence } from "../../components/SequenceProvider";

export const QuizSettingsPageManager = () => {
  const assessment_id = useParams();
  const [showSummary, setShowSummary] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation to get the current location object
  const [quizSettings, setQuizSettings] = useState({
    difficulty: "Easy",
    numberOfQuestions: 10,
    skillDistribution: {},
  });

  const { user } = useContext(AuthContext);
  const [quizCreated, setQuizCreated] = useState(false);
  const { canAttemptQuiz, quizStarted, allowQuizAttempt, resetQuizAttempt } =
    useQuizContext();
  const [user_id, setUserId] = useState(user?.user_id);
  const [queryCount, setQueryCount] = useState(0);
  const productCount = location.state?.productCount || 0;
  const selectedUsers = location.state?.selectedUsers || [];
  const [manager_id, setManagerId] = useState(user?.user_id);
  const { completeSequence } = useSequence();
  // Function to format the date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };

  // Function to format the time as HH:MM:SS
  const formatTime = (date) => {
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    const seconds = `0${date.getSeconds()}`.slice(-2);
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleStartAssessment = async () => {
    try {
      const now = new Date();
      const currentDate = formatDate(now); // Get the formatted date
      const currentTime = formatTime(now); // Get the formatted time

      const data = {
        user_id: user?.user_id,
        assessment_id: assessment_id,
        subProductSkillIds: quizSettings.skillDistribution,
        difficulty:
          quizSettings.difficulty === "Easy"
            ? "0"
            : quizSettings.difficulty === "Intermediate"
              ? "1"
              : "2",
        query_count: quizSettings.numberOfQuestions,
        date: currentDate,
        time: currentTime,
        manager_id: manager_id,
        selectedUsers: selectedUsers,
      };
      
      const response = await axios.post(
        `${API_URL}/manager/quiz/startAssessment`,
        data,
      );

      if (response) {
        const query_count = data.query_count;
        setQueryCount(query_count);
        if (!quizStarted) {
          allowQuizAttempt();
        }
        setQuizCreated(true);
      } else {
        alert("Failed to start assessment.");
      }
    } catch (error) {
      console.error("Error starting assessment:", error);
      alert("An error occurred while starting the assessment.");
    }
  };

  const handleSubmit = ({ totalQuestions, skillDistribution }) => {
    
    setQuizSettings({
      ...quizSettings,
      numberOfQuestions: totalQuestions, // Update total questions
      skillDistribution: skillDistribution, // Include skill-based question distribution
    });
    setShowSummary(true); // Move to the summary page
  };

  const handleModify = () => {
    setShowSummary(false);
  };
  const handleQuizStarted = async () => {
    try {
      await axios.post(`${API_URL}/manager/quizDistribution`, {
        assessment_id: assessment_id,
        skillDistribution: quizSettings.skillDistribution,
      });
      completeSequence(true); // Mark the sequence as completed
      navigate(`/${manager_id}/manager/assessments`, {
        replace: true,
        state: {
          query_count: queryCount,
          subProductSkillIds: quizSettings.skillDistribution,
        },
      });
    } catch (error) {
      console.error("Error updating quiz distribution:", error);
      alert("An error occurred while updating quiz distribution.");
    }
  };
  if (quizCreated) {
    return (
      <Layer position="center" modal>
        <Box pad="medium" gap="small" width="medium" align="center">
          <Text weight="bold" alignSelf="center" align="center">
            To complete creating assessment, please click the button below.
          </Text>
          <Box align="center">
            <Button
              label="Create Assessment"
              color="brand"
              onClick={() => handleQuizStarted()}
              secondary
            />
          </Box>
        </Box>
      </Layer>
    );
  }
  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box flex="grow">
          {/* )} */}

          {!showSummary ? (
            <QuizFields
              onSubmit={handleSubmit}
              productCount={productCount}
              data={user_id}
              assessment_id={assessment_id}
            />
          ) : (
            <QuizSummary
              difficulty={quizSettings.difficulty}
              numberOfQuestions={quizSettings.numberOfQuestions}
              onModify={handleModify}
              onStart={handleStartAssessment} // Call handleStartAssessment on start
            />
          )}
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};
